import { render } from "./Header.vue?vue&type=template&id=561bdbe4"
import script from "./Header.vue?vue&type=script&lang=js"
export * from "./Header.vue?vue&type=script&lang=js"

import "./Header.vue?vue&type=style&index=0&id=561bdbe4&lang=scss"

import exportComponent from "C:\\Users\\Alexander\\Documents\\Hompage TT Tools\\TT Homapge Files\\Webseite\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__